/* eslint-disable @typescript-eslint/no-shadow */

/* eslint-disable no-shadow */
import React from 'react';
import { Box } from 'pounceV2';
import groupBy from 'lodash/groupBy';
import { useTheme } from '@mui/material';
import { SharedMenuItemsProps } from './MenuItemsV3';

/**
 * Acts as a wrapper of StaticMenuItems in a list of dropdown options,
 * to allow grouping.
 */
function StaticMenuItemsV3<Item>({
  items,
  renderItem,
  itemToGroup,
}: SharedMenuItemsProps<Item>): React.ReactElement<SharedMenuItemsProps<Item>> {
  const {
    palette: { componentTokens, typographyTokens },
  } = useTheme();
  const groupedItems = React.useMemo(() => {
    return groupBy(items, itemToGroup);
  }, [items, itemToGroup]);

  if (!itemToGroup) {
    return <>{items.map(item => renderItem({ item }))}</>;
  }

  return (
    <>
      {Object.entries(groupedItems).map(([groupName, items]) => {
        return (
          <Box aria-label={`Group ${groupName}`} as="li" key={groupName} sx={{ listStyle: 'none' }}>
            {groupName && (
              <Box
                position="sticky"
                backgroundColor={
                  componentTokens.selectMenuItems.color.item.background.containerBase
                }
                color={componentTokens.selectMenuItems.color.item.text.header.resting}
                top={0}
                fontWeight={typographyTokens.fontWeights.bold}
                zIndex={1}
                p={3}
              >
                {groupName}
              </Box>
            )}
            <Box as="ul" role="listbox">
              {items.map(item => renderItem({ item, isNested: true }))}
            </Box>
          </Box>
        );
      })}
    </>
  );
}

export default StaticMenuItemsV3;
